<template>
  <div class="min-h-screen">
    <SiteHeader :page-name="'Account Info'" />
    <div class="m-4">
      <Card>
        <template #title>
          <div class="flex flex-row">
            <div class="rounded-full border-8 border-surface-700 dark:border-surface-200 w-fit h-fit">
              <i class="pi pi-user text-8xl p-6"></i>
            </div>
            <div class="flex flex-col h-fit my-auto ml-5">
              <div class="flex flex-row mb-4 gap-3">
                <p class="text-4xl">My Account</p>
                <i v-if="entity && entity.webAccountStatus" v-tooltip.top="'Web Enabled'" class="text-info-500 my-auto pi pi-globe text-2xl"></i>
                <i v-if="entity && entity.webAccountReadOnly" v-tooltip.top="'Read Only'" class="text-help-500 my-auto pi pi-book text-2xl"></i>
                <i v-if="entity && entity.active" v-tooltip.top="'Active'" class="text-success-500 my-auto pi pi-check-circle text-2xl"></i>
                <i v-else-if="entity" v-tooltip.top="'Inactive'" class="text-danger-500 my-auto pi pi-times-circle text-2xl"></i>
                <i v-if="entity && entity.licensee" v-tooltip.top="'Licensee'" class="text-primary-500 my-auto pi pi-money-bill text-2xl"></i>
                <i
                  v-if="entity && entity.primaryLender"
                  v-tooltip.top="'Primary Lender'"
                  class="text-secondary-500 my-auto pi pi-verified text-2xl"
                ></i>
              </div>

              <p class="text-2xl font-bold">
                {{ userInfo.firstName + " " + userInfo.lastName
                }}<span v-if="entity && entity.companyName.length > 0"> - {{ entity.companyName }}</span>
              </p>
              <p class="font-normal! text-base! italic">{{ userInfo.email }}</p>
              <p class="font-normal! text-base! italic">{{ entity?.entityPhone }}</p>
            </div>
          </div>
        </template>
        <template #content>
          <p class="whitespace-pre-wrap">
            {{ address }}
          </p>
          <div>
            <label class="font-bold text-xl">Username: </label>
            <span class="text-xl">{{ userInfo.username }}</span>
          </div>
        </template>
        <template #footer>
          <RouterLink to="/changepass"> <Button label="Change Password" /> </RouterLink>
        </template>
      </Card>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAuthStore } from "@/stores/auth";
import { EntitySchema, type Entity } from "@/types/Entity";

const entity = ref<Entity>();
const address = ref("");

const userInfo = useAuthStore().getUserInfo();

onBeforeMount(async (): Promise<void> => {
  axios
    .get("/entities/" + userInfo.entity)
    .then((response) => {
      handleApiResponse(
        response,
        (data: any) => {
          parseData(EntitySchema, data, entity);

          if (entity.value == null) return;
          if (entity.value.addressLine1.length > 0) address.value = entity.value.addressLine1 + "\n";
          if (entity.value.addressLine2.length > 0) address.value += entity.value.addressLine2 + "\n";
          if (entity.value.city.length > 0)
            address.value += entity.value.city + ", " + (entity.value.state == null ? "" : entity.value.state) + ", " + entity.value.zip;
        },
        (errors: ApiError[]) => {
          error("Error Occurred", errors[0].message);
        }
      );
    })
    .catch((e) => errorApi(e));
});
</script>
